import React from 'react';

import CancelOffer from '../Partials/CancelOffer';
import AttendeeList from '../Partials/AttendeeList';
import { Row, Col } from '../../Grid';
import {
  InstanceContainer,
  ClaimNumber,
  WaitlistInfo,
  CancelButton,
  CanceledButton,
} from './Common';
import OfferName from '../Partials/OfferName';

interface Props {
  offer: Offer;
  type: string;
}

interface State {
  attendees: boolean;
  cancel: boolean;
}

class OfferInstance extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { cancel: false, attendees: false };
  }

  openClaims() {
    if (this.props.offer.attendees && this.props.offer.attendees.length)
      this.setState({ attendees: true });
  }

  render() {
    return (
      <InstanceContainer>
        {this.state.attendees ? (
          <AttendeeList
            attendees={this.props.offer.attendees}
            close={() => this.setState({ attendees: false })}
            offer={this.props.offer}
          />
        ) : null}
        <Row>
          <Col size="0 0 270px">
            <OfferName offer={this.props.offer} />
          </Col>
          <Col size="1">
            <div className="float-left">
              <ClaimNumber
                onClick={() => this.openClaims()}
                underline={this.props.offer.taken_spots !== 0}
              >
                <span style={{ fontFamily: 'BrandonGrotesque-Bold' }}>
                  {this.props.offer.taken_spots}/
                  {this.props.offer.available_spots === -1 ? '∞' : this.props.offer.available_spots}{' '}
                </span>{' '}
                Claims
              </ClaimNumber>
            </div>
            {this.props.offer.waitlist_spots ? (
              <div className="float-left">
                <WaitlistInfo>{this.props.offer.waitlist_spots} on waitlist</WaitlistInfo>
              </div>
            ) : null}
          </Col>

          {this.props.offer.type === 'job' && this.props.offer.deal_call_sheet_ready === false ? (
            <Col size="1">
              <a href={`/offers/${this.props.offer.id}/callSheet`}>
                <ClaimNumber underline={true} style={{ color: 'var(--color-gunmetal)' }}>
                  Add Call Sheet Info
                </ClaimNumber>
              </a>
            </Col>
          ) : null}

          {this.props.offer.state !== 'past' && !this.props.offer.canceled_at ? (
            <Col size="0 0 100px">
              <div className="float-right">
                <CancelOffer offer={this.props.offer}>
                  <div>
                    <CancelButton right />
                  </div>
                </CancelOffer>
              </div>
            </Col>
          ) : null}

          {(this.props.offer.state === 'canceled' || this.props.offer.canceled_at) && (
            <Col size="0 0 109px">
              <CanceledButton>CANCELED</CanceledButton>
            </Col>
          )}
        </Row>
      </InstanceContainer>
    );
  }
}

export default OfferInstance;
